import React from "react"

const Hamburger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.022"
      height="17.013"
      viewBox="0 0 28.022 17.013"
    >
      <g
        id="Hamburger_Menu"
        data-name="Hamburger Menu"
        transform="translate(0 0.5)"
      >
        <line
          id="Line_22"
          data-name="Line 22"
          x2="28.022"
          fill="none"
          stroke="#0d3552"
          strokeWidth="1"
        />
        <line
          id="Line_23"
          data-name="Line 23"
          x2="8.819"
          transform="translate(0 8.006)"
          fill="none"
          stroke="#0d3552"
          strokeWidth="1"
        />
        <line
          id="Line_25"
          data-name="Line 25"
          x2="8.819"
          transform="translate(19.203 8.006)"
          fill="none"
          stroke="#0d3552"
          strokeWidth="1"
        />
        <line
          id="Line_24"
          data-name="Line 24"
          x2="28.022"
          transform="translate(0 16.013)"
          fill="none"
          stroke="#0d3552"
          strokeWidth="1"
        />
        <path
          id="Polygon_12"
          data-name="Polygon 12"
          d="M4,0,8,7H0Z"
          transform="translate(10.5 4.025)"
          fill="#0d3552"
        />
      </g>
    </svg>
  )
}

export default Hamburger
